import _styled from "styled-components";
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';
import * as styles from "./CopyBlock.styles";
export var CopyBlock = function CopyBlock(_ref) {
  var alignment = _ref.alignment,
    children = _ref.children,
    onLinkClick = _ref.onLinkClick,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    observedElementRef = _useVisibilityObserve.observedElementRef;
  var handleClick = function handleClick(e) {
    if (getAnchorElementFromEvent(e)) {
      onLinkClick === null || onLinkClick === void 0 || onLinkClick(e);
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    React.createElement(_StyledDiv, {
      onClick: handleClick,
      ref: observedElementRef,
      style: {
        '--textAlignment': alignment
      },
      $_css: styles.copyContainer
    }, children)
  );
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "CopyBlock___StyledDiv",
  componentId: "sc-144vy6p-0"
})(["", ""], function (p) {
  return p.$_css;
});